import { styled } from '@egoist/vue-emotion'
import { mapGetters, mapState } from '../../../../builder/node_modules/vuex'
import * as getters from '../../../../builder/src/js/store/modules/getters'
import { CvtIcon } from '../../molecules/icon/icon'
import CvtSelect from '../../molecules/Select'


let FontFamily, 
Spacing, 
Radii, 
Colors, 
Border, 
textFontWeight, 
color, 
backgroundColor, 
textFontSize, 
elevation, 
textColor, 
IconSize


const getLeftNav = () => styled('aside')`
  display: flex;
  flex-direction: column; 
  width: 320px;
  font-family: ${FontFamily.DEFAULT};
  background-color: #fff;
  z-index: 1;
  padding-bottom: ${Spacing.SPACING_64}px;

  @media (max-width: 768px) {
    width: 150px;
  }
`

const getNavItem = () => styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-stretch;
  ${color({ themeing: 'dark' }, 500)}
  ${textFontSize('lg')}
  ${textFontWeight('LIGHT')}
  height: 72px;
  
  &:hover, :focus, :active {
    ${color({ themeing: 'dark' }, 'WHITE')} !important;
    background-color: ${Colors.BASIC[100]};
    cursor: pointer;
  }
  &.isActive {
    ${color({ themeing: 'primary' }, 500)}
    background-color: ${Colors.BASIC[100]};
  }
`

const getNavItemInsideWrap = () => styled('div')`
  height: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  ${(props) => {
    let styles = ``
      styles += props.isText
        ? `flex: 1; border-bottom: 1px solid ${Colors.BASIC[100]};`
        : `padding: 0 ${Spacing.SPACING_24}px;`

    return styles
  }}
  ${(props) => {
    if (props.isActive) {
      return color({ themeing: 'dark' }, 700)
    } else {
      return props.mode === 'DARK'
        ? color({ themeing: 'light' }, 100)
        : color({ themeing: 'dark' }, 700)
    }
  }}
`
const getNavIcon = () => styled(CvtIcon)`
  width: ${Spacing.SPACING_16}px;
  font-size: ${IconSize.ICON_SIZE_XL}px;
`

const getNavText = () => styled('span')`
  margin: 0 ${Spacing.SPACING_4}px;
`

const getSelectContainer = () => styled('div')`
  width: 100%;
  padding: ${Spacing.SPACING_24}px ${Spacing.SPACING_12}px;
`

const getSelectWrapper = () => styled('div')`
  padding: ${Spacing.SPACING_4}px ${Spacing.SPACING_8}px;
`

const getSelectField = () => styled(CvtSelect)`
  width: 100%;
`

export const EnterpriseLeftNavBar = {
  name: 'EnterpriseLeftNavBar',
  data () {
    return {
      activeId: this.initialActiveId,
    }
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT'      
    },
    usage: {
      type: String,
      default: 'select-template'
    },
    type: {
      type: String,
      default: 'standard'
    },
    navigationItems: {
      type: Array,
      default: () => []
    },
    fixed: {
      type: Boolean,
      default: true
    },
    initialActiveId: {
      type: String,
      default: ''
    },
    counts: {
      type: Object,
      default: null
    },
    showCount: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters ('globalTheme', {
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      textColor: getters.GLOBAL_STYLE_COLOR,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      elevation: getters.GLOBAL_STYLE_ELEVATION,
    }),
    ...mapState ('globalTheme', {
      iconConfig: ({ iconConfig }) => iconConfig,
      FontFamily: ({ globalTheme }) => globalTheme.FontFamily,
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      Radii: ({ globalTheme }) => globalTheme.Radii,
      Colors: ({ globalTheme }) => globalTheme.Colors,
      Border: ({ globalTheme }) => globalTheme.Border,
      IconSize: ({ globalTheme }) => globalTheme.IconSize,
      fieldlabelStyles: ({ globalTheme }) => globalTheme.fieldlabelStyles ? globalTheme.fieldlabelStyles: "",
    })
  },
  methods: {
    onNavItemClicked (item) { this.$emit('navItemClicked', item) },
    itemIcon (item) {
      const categories = this.iconConfig['marketplaceCategories']
      let id = item.id
      switch(id){
        case null:
          id = 'all'
          break;
        case 'your-pages':
          id = 'ebook'
          break;
        case 'archived-pages':
          id = 'archived-templates'
          break;
      }
      return item.icon ? item.icon : categories[id] 
    }
  },
  created () {
    FontFamily = this.FontFamily
    Spacing = this.Spacing
    Radii = this.Radii
    Colors = this.Colors
    Border = this.Border
    IconSize = this.IconSize
    textFontWeight = this.textFontWeight
    color = this.textColor
    backgroundColor = this.backgroundColor
    textFontSize = this.textFontSize
    elevation = this.elevation
    textColor = this.textColor
  },
  render: function (h) {
    const LeftNav = getLeftNav()
    const NavItem = getNavItem()
    const NavItemInsideWrap = getNavItemInsideWrap()
    const NavIcon = getNavIcon()
    const NavText = getNavText()
    const SelectContainer = getSelectContainer()
    const SelectWrapper = getSelectWrapper()
    const SelectField = getSelectField()
    let navigationItems = this.navigationItems

    const navItems = navigationItems.map((item) => {
      let activeFlag = item.id === this.activeId
      return (
        <NavItem
          mode={this.mode}
          type={this.type}
          class={{ isActive: activeFlag }}
          usage={this.usage}
          onClick={() => {
            this.activeId = item.id
            this.onNavItemClicked(item)
          }}
        >
          <NavItemInsideWrap
            mode={this.mode}
            isText={false}
            type={this.type}
            usage={this.usage}
            isActive={activeFlag}
          >
            <NavIcon
              icon={this.itemIcon(item)}
              type={this.type}
            ></NavIcon>
          </NavItemInsideWrap>
          <NavItemInsideWrap
            mode={this.mode}
            isText={true}
            type={this.type}
            usage={this.usage}
            isActive={activeFlag}
          >
            <NavText>{item.label}</NavText>
          </NavItemInsideWrap>
        </NavItem>
      )
    })
    return (
      <LeftNav
        mode={this.mode}
        type={this.type}
        usage={this.usage}
        class={{ __fixed: this.fixed }}
      >
        <SelectContainer>
          <SelectWrapper>
            <SelectField
              mode='dropdown'
              value="'usage'"
              labelType="standard"
              label='Usage'
              background-mode='mode'
              fieldlabelStyles={this.fieldlabelStyles}
              selectRadius="8"
            >
              <option>Goals</option>
            </SelectField>
          </SelectWrapper>
          <SelectWrapper>
            <SelectField
              mode='dropdown'
              value="'industry'"
              labelType="standard"
              label='Industry'
              background-mode='mode'
              fieldlabelStyles={this.fieldlabelStyles}
              selectRadius="8"
            >
              <option>Industry</option>
            </SelectField>
          </SelectWrapper>
        </SelectContainer>
        {navItems}
      </LeftNav>
    )
  }
}
